import { Navigate, Outlet } from "react-router-dom";
import useAuth from "src/hooks/useAuth";
import AuthLayout from "src/layout/AuthLayout";
import ScreenLoader from "./screenLoader";

interface Props {
  isbillingGuard?: boolean;
}

const GuestGuard: React.FC<Props> = ({ isbillingGuard = false }) => {
  const { loading, isAuthenticated } = useAuth();

  if (loading) return <ScreenLoader />;

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (isbillingGuard) {
    return <Outlet />;
  }

  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
};

export default GuestGuard;
